var map = {
	"./BASE.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/BASE.svg",
	"./BF.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/BF.svg",
	"./BJ.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/BJ.svg",
	"./BTC.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/BTC.svg",
	"./BW.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/BW.svg",
	"./CD.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/CD.svg",
	"./CELO.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/CELO.svg",
	"./CG.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/CG.svg",
	"./CI.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/CI.svg",
	"./CM.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/CM.svg",
	"./CUSD.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/CUSD.svg",
	"./ERC20.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/ERC20.svg",
	"./ETH.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/ETH.svg",
	"./GA.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/GA.svg",
	"./KE.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/KE.svg",
	"./MATIC.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/MATIC.svg",
	"./ML.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/ML.svg",
	"./MW.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/MW.svg",
	"./NG.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/NG.svg",
	"./POL.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/POL.svg",
	"./POLYGON.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/POLYGON.svg",
	"./PYUSD.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/PYUSD.svg",
	"./RLUSD.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/RLUSD.svg",
	"./RW.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/RW.svg",
	"./SN.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/SN.svg",
	"./SOL.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/SOL.svg",
	"./Search.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/Search.svg",
	"./TG.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/TG.svg",
	"./TON.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/TON.svg",
	"./TRC20.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/TRC20.svg",
	"./TRON.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/TRON.svg",
	"./TZ.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/TZ.svg",
	"./Text.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/Text.svg",
	"./UG.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/UG.svg",
	"./USDC.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/USDC.svg",
	"./USDT.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/USDT.svg",
	"./XAUT.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/XAUT.svg",
	"./XLM.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/XLM.svg",
	"./XRP.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/XRP.svg",
	"./ZA.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/ZA.svg",
	"./ZM.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/ZM.svg",
	"./angle-down.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/angle-down.svg",
	"./check-circle.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/check-circle.svg",
	"./circleInfo.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/circleInfo.svg",
	"./close-alt.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/close-alt.svg",
	"./copy-white.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/copy-white.svg",
	"./copy.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/copy.svg",
	"./edit.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/edit.svg",
	"./eye-slash.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/eye-slash.svg",
	"./eye.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/eye.svg",
	"./greenClose.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/greenClose.svg",
	"./trash-black.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/trash-black.svg",
	"./trash.svg": "./node_modules/@yellowcard/components-library-vue3/lib/assets/trash.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/@yellowcard/components-library-vue3/lib/assets sync recursive ^\\.\\/.*\\.svg$";